module.exports = __webpack_public_path__ + "img/banner-2.3ad5eb43.jpg";